"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeColors = exports.inactiveTextColor = exports.focusBorderOuter = exports.focusBorderInner = exports.hoverFill = exports.normalTextColor = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = require("styled-components");

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var base = _color.default.base,
    interaction = _color.default.interaction,
    opacity = _color.default.opacity;
var normalTextColor = (0, _toColorString.default)(interaction.pacificOcean);
exports.normalTextColor = normalTextColor;
var hoverFill = (0, _toColorString.default)(interaction.pacificOcean15);
exports.hoverFill = hoverFill;
var focusBorderInner = (0, _toColorString.default)(interaction.pacificOcean);
exports.focusBorderInner = focusBorderInner;
var focusBorderOuter = (0, _toColorString.default)(interaction.pacificOcean40);
exports.focusBorderOuter = focusBorderOuter;
var inactiveTextColor = (0, _toColorString.default)(opacity.charcoal40);
exports.inactiveTextColor = inactiveTextColor;
var activeTextColor = (0, _toColorString.default)(base.snowWhite);
var activeFill = (0, _toColorString.default)(interaction.pacificOcean);
var activeColors = (0, _styledComponents.css)({
  color: activeTextColor,
  backgroundColor: activeFill
});
exports.activeColors = activeColors;